<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <b-card>
            <template v-slot:header v-if="items.length > 0">
              <b-row>
                <b-col class="text-right">
                  <b-button class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.notes_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
                </b-col>
              </b-row>
              <b-row>
                <b-col>
                  <b-collapse id="notes_search_collapse" class="mt-2">
                    <NotesFiltering :getPage="getPage"></NotesFiltering>
                  </b-collapse>
                </b-col>
              </b-row>
            </template>
          <div class="card-body">
            <Loader v-if="isLoading" size="lg"></Loader>
            <div v-else>
              <div class="col-lg-12">
                <div class="card">
              <div v-if="items.length > 0">
                <table class="table table-striped table-hover">
                  <thead>
                  <tr>
                    <th>{{$t('views.excmnote.list.title')}} :</th>
                    <th>{{$t('views.excmnote.list.table.goToCase')}} :</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr
                    v-for="item in items"
                    :key="item['@id']">
                    <td>
                      <router-link v-if="item" :to="{name: 'EXCMNoteShow', params: { id: item['@id'] }}">{{ item['title'] }}</router-link>
                    </td>
                    <td>
                      <router-link v-if="item && item.idCase" :to="{name: 'EXCMCaseShow', params: { id: item.idCase['@id'] }}">
                        <button class="btn btn-link fa fa-arrow-right" v-b-tooltip.hover :title="$t('views.excmnote.list.table.goToCase')"></button>
                      </router-link>
                    </td>
                  </tr>
                  </tbody>
                </table>
            <!--          <router-link-->
            <!--            :to="{ name: 'EXCMNoteCreate' }"-->
            <!--            class="btn btn-primary">{{$t('buttons.create')}}</router-link>-->
            <span v-if="view">
           <pagination
             :view="view"
             @getPage="getPage($event)"
           ></pagination>
        </span>
              </div>
              <div v-else>
                {{$t('views.excmnote.list.noNotes')}}
              </div>
                </div>
              </div>
          </div>
        </div>
      </b-card>
    </b-col>
  </b-row>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { checkPagePermission } from '@/utils/checkRoles.js'
import NotesFiltering from './components/NotesFiltering/NotesFiltering'
import Loader from '../../Layout/Loader'
import addParamsToQuery from '@/utils/addParamsToQuery'
import Pagination from '../../Layout/Pagination'

export default {
  components: {
    NotesFiltering,
    Loader,
    Pagination
  },

  computed: {
    mobileView () {
      return this.$store.state.mobileView
    },
    ...mapGetters({
      deletedItem: 'excmnote/del/deleted',
      error: 'excmnote/list/error',
      items: 'excmnote/list/items',
      isLoading: 'excmnote/list/isLoading',
      view: 'excmnote/list/view'
    })
  },

  data () {
    return {
      searchParams: {
        state: 1
      }
    }
  },

  beforeCreate () {
    checkPagePermission('notes', 'EXCMNoteList')
  },

  created () {
    let url = addParamsToQuery('e_x_c_m_notes', this.searchParams)
    this.getPage(url)
    this.channelNotesRooms = this.$store.state.Pusher.subscribe('e_x_c_m_notes')
    this.channelNotesRooms.bind('e_x_c_m_notes', data => {
      this.getPage(url)
    })
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_c_m_notes')
  },

  methods: mapActions({
    getPage: 'excmnote/list/default'
  })
}
</script>
